module.exports = __webpack_public_path__ + "img/4.45d8777f.jpg";